import { render, staticRenderFns } from "./NewProspectsKpi.vue?vue&type=template&id=773a2a8d&"
import script from "./NewProspectsKpi.vue?vue&type=script&lang=js&"
export * from "./NewProspectsKpi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports